"use strict";
'kiwi public';

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/getPrototypeOf"));
var _eventemitter = _interopRequireDefault(require("eventemitter3"));
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = _Reflect$construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var IpcBroadcastChannel = /*#__PURE__*/function (_EventEmitter) {
  (0, _inherits2.default)(IpcBroadcastChannel, _EventEmitter);
  var _super = _createSuper(IpcBroadcastChannel);
  function IpcBroadcastChannel() {
    (0, _classCallCheck2.default)(this, IpcBroadcastChannel);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(IpcBroadcastChannel, [{
    key: "init",
    value: function init() {
      try {
        // Privacy settings in firefox 104~ block broadcast channels in iframes
        this.bc = new BroadcastChannel('kiwi-ipc');
        this.bc.onmessage = this.onmessage.bind(this);
      } catch (_unused) {
        // catch
      }
    }
  }, {
    key: "send",
    value: function send(msg) {
      if (this.bc) {
        this.bc.postMessage(msg);
      }
    }
  }, {
    key: "onmessage",
    value: function onmessage(msg) {
      this.emit('message', msg);
    }
  }]);
  return IpcBroadcastChannel;
}(_eventemitter.default);
var IpcLocalStorage = /*#__PURE__*/function (_EventEmitter2) {
  (0, _inherits2.default)(IpcLocalStorage, _EventEmitter2);
  var _super2 = _createSuper(IpcLocalStorage);
  function IpcLocalStorage() {
    (0, _classCallCheck2.default)(this, IpcLocalStorage);
    return _super2.apply(this, arguments);
  }
  (0, _createClass2.default)(IpcLocalStorage, [{
    key: "init",
    value: function init() {
      window.addEventListener('storage', this.onmessage.bind(this));
    }
  }, {
    key: "send",
    value: function send(msg) {
      localStorage.setItem('kiwi-ipc', (0, _stringify.default)(msg));
      localStorage.removeItem('kiwi-ipc');
    }
  }, {
    key: "onmessage",
    value: function onmessage(msg) {
      if (msg.key === 'kiwi-ipc' && msg.newValue) {
        try {
          var parsedMsg = {
            data: JSON.parse(msg.newValue)
          };
          this.emit('message', parsedMsg);
        } catch (e) {
          this.emit('error');
        }
      }
    }
  }]);
  return IpcLocalStorage;
}(_eventemitter.default);
var _default = exports.default = window.BroadcastChannel ? new IpcBroadcastChannel() : new IpcLocalStorage();
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["IPC"]
window._kiwi_exports.libs.IPC = exports.default ? exports.default : exports;
